module.exports = __webpack_public_path__ + "static/media/Ano2019.eca03d44.jpg";